import React from 'react';

import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const ImportShowSkeleton = (): React.JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="start"
      height="100%"
    >
      <Typography variant="h1">
        <Skeleton height={90} />
      </Typography>

      <Typography variant="h2" marginBottom={2}>
        <Skeleton />
      </Typography>

      <Box display="flex" flexDirection="row" mb={3}>
        <Grid container item justifyContent="flex-end" spacing={5}>
          <Grid item md={3}>
            <Skeleton variant="rectangular" height={120} />
          </Grid>
          <Grid item md={3}>
            <Skeleton variant="rectangular" height={120} />
          </Grid>
          <Grid item md={6}>
            <Skeleton variant="rectangular" height={120} />
          </Grid>
        </Grid>
      </Box>

      <Paper>
        <Box p={2}>
          <Box mb={2}>
            <Skeleton variant="text" height={30} />
          </Box>

          <Box mb={3}>
            <Skeleton variant="rectangular" height={60} />
          </Box>

          <TableContainer
            component={Paper}
            style={{ minHeight: '380px', height: '100%' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }, (_, i) => i + 1).map((i) => (
                  <TableRow key={i}>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </Box>
  );
};

export default ImportShowSkeleton;
